import { Dealer, DealerFilterData } from '@api/types';
import { Column, SmartLink, StyledTableRow, StyledTableRowSeparator, TableCell } from '@components';
import { useAppSelector } from '@hooks';
import { getSpecialPage } from '@store/app/app.slice';
import { getDealerItems } from './dealerItem.config';

type DealerRowProps = {
  dealer: Dealer;
  filters?: DealerFilterData;
  filteredColumns?: Array<Column>;
  visibleColumnNames?: Array<string>;
  isWorking?: boolean;
};

export const DealerListRow = ({
  dealer,
  isWorking,
  visibleColumnNames,
  filteredColumns,
  filters,
}: DealerRowProps) => {
  const dealerItems = getDealerItems(dealer);
  const searchWords = filters?.Search?.split(' ') ?? [];
  const dealerDetailsBaseUrl = useAppSelector(getSpecialPage('dealerDetailsPage'));
  const dealerDetailsHref = `${dealerDetailsBaseUrl}?id=${dealer?.customerNo}`;
  return (
    <StyledTableRow iscursorpointer='true'>
      <SmartLink href={dealerDetailsHref} sx={{ display: 'contents', p: 8 }} className='link'>
        {dealerItems.map((dealerItem, index) => (
          <TableCell
            key={index}
            isWorking={isWorking}
            visibleColumnNames={visibleColumnNames}
            filteredColumns={filteredColumns}
            searchWords={searchWords}
            {...dealerItem}
          />
        ))}
      </SmartLink>
      <StyledTableRowSeparator />
    </StyledTableRow>
  );
};
